import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Form from 'components/Form';
import TextField from 'components/TextField';

import { stringToNumber, textFieldValue, useErrorHandler } from 'lib';
import { ScoroSettings_settings$key } from '__generated__/ScoroSettings_settings.graphql';
import { ScoroSettingsMutation } from '__generated__/ScoroSettingsMutation.graphql';

type FormFields = {
  apiKey: string;
  apiUrl: string;
  ownerId: string;
};

type Props = {
  settings: ScoroSettings_settings$key;
};

const ScoroSettings: FC<Props> = props => {
  const errorHandler = useErrorHandler();

  const { scoro } = useFragment(
    graphql`
      fragment ScoroSettings_settings on Settings {
        scoro {
          apiKey
          apiUrl
          ownerId
        }
      }
    `,
    props.settings
  );

  const [update, updating] = useMutation<ScoroSettingsMutation>(graphql`
    mutation ScoroSettingsMutation($input: UpdateSettingsInput!) {
      updateSettings(input: $input) {
        ...ScoroSettings_settings
      }
    }
  `);

  const initial = {
    apiKey: scoro?.apiKey ?? '',
    apiUrl: scoro?.apiUrl ?? '',
    ownerId: textFieldValue(scoro?.ownerId),
  };

  const handleSubmit = useCallback(
    ({ ownerId, ...values }: FormFields) => {
      update({
        variables: {
          input: {
            scoro: {
              ...values,
              ownerId: stringToNumber(ownerId),
            },
          },
        },

        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, update]
  );

  return (
    <Formik<FormFields> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <Paper sx={{ p: 2 }}>
          <Stack spacing={4}>
            <TextField fullWidth name="apiKey" label="API Raktas" />
            <TextField fullWidth name="apiUrl" label="API URL" />
            <TextField fullWidth name="ownerId" label="Owner ID" />
          </Stack>
        </Paper>
      </Form>
    </Formik>
  );
};

export default ScoroSettings;
